import React from "react";
import { Card, Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../../styles/General.css";
import "../../styles/HerbCategories.css";
import SEO from "../utils/SEO";
import HERB_CATEGORIES from "../../data/herbCategories";

const CategoryCard = ({ category }) => {
  const navigate = useNavigate();
  return (
    <Card
      className="herbcat-card"
      role="button"
      onClick={() => navigate(`/herbs/category/${category.slug}`)}
    >
      <div className="herbcat-card__imgwrap">
        <Card.Img variant="top" src={category.image} alt={`${category.name} herbs`} />
      </div>
      <Card.Body>
        <Card.Title className="herbcat-card__title">{category.name}</Card.Title>
        <Card.Text className="herbcat-card__desc">{category.description}</Card.Text>
      </Card.Body>
    </Card>
  );
};

const HerbCategories = () => (
  <div>
    <SEO
      title="Medicinal Herb Categories - Sarv"
      description="Browse medicinal herbs by body system — digestive, immune, respiratory, skin, calming, heart, liver, and more. Explore natural remedies and their uses."
      canonicalPath="/herbCategories"
      keywords="medicinal herb categories, herbs by body system, digestive herbs, immune herbs, calming herbs, herbal medicine directory"
    />
    <Container style={{ paddingTop: "90px", paddingBottom: "70px" }}>
      <h1 className="article-categoories-title text-center mb-2">Explore Herbs by Category</h1>
      <p className="text-center herbcat-intro">
        Browse our medicinal herb library by the body system they support.
      </p>
      <Row xs={1} sm={2} lg={3} className="g-4 mt-2">
        {HERB_CATEGORIES.map((category) => (
          <Col key={category.slug}>
            <CategoryCard category={category} />
          </Col>
        ))}
      </Row>
    </Container>
  </div>
);

export default HerbCategories;
